import { DamPermissionsMap } from '@surgetech-eu/ewc-dam'
import { Injectable } from '@angular/core'
import { PermissionConfig, PermissionsGuard } from '@surgetech-eu/core'

@Injectable()
export class AppPermissionsGuard extends PermissionsGuard {
    getPermissionMap(): PermissionConfig[] {
        return [
            ...DamPermissionsMap,
            {
                requiredAction: 'accessEverythingExceptDam',
                menuItemNames: [
                    'prepare',
                    'manage',
                    'link',
                    'assign',
                    'propose',
                    'certification',
                    'history',
                    'versioning-history',
                    'linked',
                    'catalog',
                    'sap-integration',
                    'value-chain',
                    'suggested-measures',
                    'audit',
                    'baseMaterial',
                    'secondary-packaging',
                    'packaging-material',
                    'techDesign',
                    'component',
                    'galvman',
                    'galvanicTreatment',
                    'galvanicTreatmentPrepare',
                    'galvanicTreatmentManage',
                    'galvanicTreatmentView',
                    'galvmanPlatingMaterials',
                    'galvmanDataSheets',
                    'galvmanHistory',
                    'galvmanCertification',
                    'galvmanSelectAndCreate',
                    'galvmanUploadAndCreate',
                    'galvmanPlayer',
                    'galvmanView',
                    'galvmanPlatingMaterial'
                ],
                urlMasks: [
                    '/catalog/**',
                    '/settings/**',
                    '/eyewear/**',
                    '/case/**',
                    '/sap-integration/**',
                    '/history/**',
                    '/value-chain/**',
                    '/suggested-measures/**',
                    '/audit/**',
                    '/mapping/**',
                    '/secondary-packaging/**',
                    '/tech-drawing/**',
                    '/component/**',
                    '/galvman/**'
                ]
            },
            {
                urlMasks: '',
                requiredAction: 'accessEverythingExceptDam',
                redirectUrl: '/product-images'
            },
            {
                urlMasks: '/user-management',
                requiredAction: 'manageUsers',
                menuItemNames: 'user-management'
            }
        ]
    }
}
